import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { Icon } from 'components/common/icons';
import { Datepicker } from '.';

import type {
  ButtonCategory,
  ButtonInterface,
  ButtonSize
} from 'components/common/Button';

interface Props {
  align?: 'left' | 'right';
  ariaLabel?: string;
  category?: ButtonCategory;
  field: string;
  id?: string;
  initialValue?: number;
  maxDate?: number;
  onChange?: (date: number) => void;
  onClear?: () => void;
  placeholder?: string;
  size?: ButtonSize;
}

const DatepickerButton = ({
  ariaLabel,
  category = 'lighter',
  onClear,
  placeholder,
  size = 'header',
  ...props
}: Props) => {
  const { messages } = useReduxState();

  const handleClear = (ev) => {
    ev.stopPropagation();
    onClear();
  };

  const CustomInput = ({ onClick, ref, value }: ButtonInterface) => (
    <Button
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      category={category}
      onClick={onClick}
      ref={ref}
      size={size}
      text={
        <span className="content">
          {value || placeholder || ''}

          {value && onClear ? (
            <Icon
              data-tooltip={messages.commonClear}
              icon="times-circle"
              onClick={handleClear}
              style={{
                fontSize: '1.2rem',
                marginLeft: 5,
                position: 'relative',
                top: -0.5
              }}
            />
          ) : null}

          <Icon
            icon={['far', 'calendar-alt']}
            style={{
              fontSize: '1.2rem',
              marginLeft: 10,
              position: 'relative',
              top: -1
            }}
          />
        </span>
      }
    />
  );

  return (
    <Datepicker customInput={<CustomInput />} showIcon={false} {...props} />
  );
};

export default DatepickerButton;
